import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import { AppShell } from "@/features/layout";
import { ProtectedApp } from "@/features/layout/components/ProtectedApp";
import { PublicSiteLayout } from "@/features/public/layout/PublicSiteLayout";
import { DashboardPage } from "@/features/dashboard";
import {
  BulkExportPage,
  BulkCreditNotesExportPage,
  CreditNotesPage,
  PayLinksPage,
  PdfsPage,
  ReceiptsPage,
} from "@/features/invoices";
import { ExportsPage, ExportDetailPage } from "@/features/exports";
import { CreditsPage } from "@/features/credits";
import { DocsPage } from "@/pages/public/DocsPage";
import { PublicHomePage } from "@/pages/public/PublicHomePage";
import { PublicPricingPage } from "@/pages/public/PublicPricingPage";
import { HelpPage } from "@/pages/static/HelpPage";
import { LegalPage } from "@/pages/static/LegalPage";
import { ROUTES } from "@/config/routes";
import { AuthEntryPage } from "@/pages/auth/AuthEntryPage";
import { AppUninstalledPage } from "@/pages/auth/AppUninstalledPage";
import { SessionExpiredPage } from "@/pages/auth/SessionExpiredPage";
import { WelcomePage } from "@/pages/auth/WelcomePage";

const router = createBrowserRouter([
  { path: "/", element: <Navigate to={ROUTES.dashboard} replace /> },
  { path: ROUTES.authEntry, element: <AuthEntryPage /> },
  { path: ROUTES.welcome, element: <WelcomePage /> },
  { path: ROUTES.sessionExpired, element: <SessionExpiredPage /> },
  { path: ROUTES.appUninstalled, element: <AppUninstalledPage /> },
  {
    element: <PublicSiteLayout />,
    children: [
      { path: ROUTES.home, element: <PublicHomePage /> },
      { path: ROUTES.pricing, element: <PublicPricingPage /> },
      { path: ROUTES.help, element: <HelpPage /> },
      { path: ROUTES.legal, element: <LegalPage /> },
      { path: ROUTES.privacy, element: <LegalPage focusSection="privacy" /> },
      { path: ROUTES.terms, element: <LegalPage focusSection="terms" /> },
      { path: ROUTES.docs, element: <DocsPage /> },
    ],
  },
  {
    element: <ProtectedApp />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: ROUTES.dashboard, element: <DashboardPage /> },
          {
            path: ROUTES.invoices,
            element: <Navigate to={ROUTES.invoicesPdfs} replace />,
          },
          { path: ROUTES.invoicesBulkExport, element: <BulkExportPage /> },
          { path: ROUTES.invoicesCreditNotesBulkExport, element: <BulkCreditNotesExportPage /> },
          { path: ROUTES.invoicesPdfs, element: <PdfsPage /> },
          { path: ROUTES.invoicesReceipts, element: <ReceiptsPage /> },
          { path: ROUTES.invoicesCreditNotes, element: <CreditNotesPage /> },
          { path: ROUTES.invoicesPayLinks, element: <PayLinksPage /> },
          { path: ROUTES.exports, element: <ExportsPage /> },
          { path: "/exports/:jobId", element: <ExportDetailPage /> },
          { path: ROUTES.billing, element: <CreditsPage /> },
          {
            path: ROUTES.credits,
            element: <Navigate to={ROUTES.billing} replace />,
          },
        ],
      },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
